module.exports = new Promise((resolve, reject) => {
                    if (typeof window === 'undefined' && typeof process === 'undefined') {
                        return reject(new Error('window is not defined'));
                    }
                    const url = 'https://mfe-ui.gv.qa.ea.vistajet.com/remoteEntry.js';
                    const script = function createScript(remoteUrl, path, resolve, reject, runtime = 'dev') {
   const isProd = runtime === 'prod';

   const handleScriptLoad = () => {
      if (!window[path]) {
         const msg = `Remote "${path}" did not register correctly`;
         if (isProd) {
            console.error(msg);
            reject(new Error(`Remote "${path}" failed`));
         } else {
            reject(new Error(`${msg} (expected global window["${path}"])`));
         }
         return;
      }

      const proxy = {
         get: (request) => window[path].get(request),
         init: (arg) => {
            try {
               return window[path].init(arg);
            } catch (e) {
               console.warn(`Remote "${path}" already initialized`);
            }
         },
      };
      resolve(proxy);
   };

   const script = document.createElement('script');
   script.src = remoteUrl;
   script.async = true;

   script.onload = handleScriptLoad;

   script.onerror = () => {
      const devMsg = `Failed to load remote: ${path} (${remoteUrl})`;
      const prodMsg = `Remote "${path}" is temporarily unavailable`;

      // Always log detailed info to console for debugging
      console.error(devMsg);

      // Store error for diagnostics
      window.localStorage.setItem(`error:${path}`, devMsg);

      // Reject with simplified error in prod
      reject(new Error(isProd ? prodMsg : devMsg));
   };

   return script;
}(
                        url,
                        'uiContainer',
                        resolve,
                        reject,
                        "qa"
                    );
                    document.head.appendChild(script);
                });;